var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.003 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.667.005a2.42 2.42 0 00-1.673.708L7.067 9.627a.667.667 0 00-.177.315l-.738 3.1a.667.667 0 00.807.8l3.1-.738a.667.667 0 00.315-.177l8.918-8.918a2.371 2.371 0 00.044-3.341 2.3 2.3 0 00-1.669-.663zm.016 1.323a.968.968 0 01.712.286 1.021 1.021 0 01-.044 1.462l-.2.2-1.413-1.418.2-.2a1.09 1.09 0 01.745-.331zm-14.907.37A2.776 2.776 0 00.005 4.464v12.771a2.781 2.781 0 002.762 2.77h12.771a2.781 2.781 0 002.771-2.771V8.898a.667.667 0 10-1.335 0v8.336a1.42 1.42 0 01-1.436 1.437H2.767a1.421 1.421 0 01-1.437-1.437V4.459a1.42 1.42 0 011.437-1.436h8.282a.665.665 0 000-1.329zm13.021 1.1l1.413 1.413-6.624 6.627-1.415-1.415zm-7.569 7.568l1.415 1.415-.072.072-1.859.443.443-1.855z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgEdit;